export enum ENUM__environment_type {
  LOCAL = 'local',
  STAGING = 'staging',
  PRODUCTION = 'production',
}
